// extracted by mini-css-extract-plugin
module.exports = {"root":"gallery_root__2pTi2","margn":"gallery_margn__26urx","items":"gallery_items__2UTHD"};